import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "USERS";
export const activityUserConstants = createCRUDConstants(nameSpace);

export const activityLog_nameSpace = "ACTIVITY_LOG";
export const activityLogConstants = createCRUDConstants(activityLog_nameSpace);

export const auditBy_nameSpace = "AUDIT_BY";
export const auditByConstants = createCRUDConstants(auditBy_nameSpace);
